export enum ThresholdSource {
  ALARM = 'ALARM',
  CUSTOM = 'CUSTOM',
  DYNAMIC = 'DYNAMIC',
}
